var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinpointGeolocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8057 0.367188C22.3472 0.367188 28.4609 6.48092 28.4609 14.0225C28.4609 17.9027 26.9195 21.6244 24.1758 24.3682L15.2031 33.3408C14.8127 33.7311 14.1795 33.7311 13.7891 33.3408L4.81641 24.3682C2.07267 21.6244 0.531276 17.9027 0.53125 14.0225C0.53125 6.48092 6.64498 0.367188 14.1865 0.367188H14.8057ZM14.4961 6.93945C10.8666 6.93945 7.92383 9.88125 7.92383 13.5107C7.92383 17.1402 10.8666 20.083 14.4961 20.083C18.1256 20.083 21.0684 17.1402 21.0684 13.5107C21.0684 9.88125 18.1256 6.93945 14.4961 6.93945Z",
    fill: "#F33131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinpointGeolocationIcon);
export default __webpack_public_path__ + "static/media/pinpoint-geolocation-icon.306f53fcfabd8a3fe00e858c4b241090.svg";
export { ForwardRef as ReactComponent };